import { ChevronRight } from "lucide-react";

interface BankStatementSummaryCardsProps {
  incentivos: number;
  saldo: number;
  entradas: number;
  saidas: number;
}

const formatBRL = (value: number) =>
  new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(value);

export function BankStatementSummaryCards({
  incentivos,
  saldo,
  entradas,
  saidas,
}: BankStatementSummaryCardsProps) {
  const cards = [
    {
      label: "Incentivos",
      value: incentivos,
      color: "#f6f6f6",
    },
    {
      label: "Entradas",
      value: entradas,
      color: "#13d480",
    },
    {
      label: "Saídas",
      value: saidas,
      color: "#dc4426",
    },
    {
      label: "Saldo Total",
      value: saldo,
      color: "#f6f6f6",
    },
  ];

  return (
    <div className="flex items-center gap-3">
      {cards.map((card, index) => (
        <div key={card.label} className="flex items-center gap-3">
          <div className="bg-[#121c35] rounded-lg p-3 flex flex-col flex-1 min-w-0">
            <p className="text-[#f6f6f6] text-xs font-normal mb-0.5">
              {card.label}
            </p>
            <p
              className="text-lg font-bold"
              style={{ color: card.color }}
            >
              {formatBRL(card.value)}
            </p>
          </div>

          {index < cards.length - 1 && (
            <ChevronRight className="w-3 h-3 text-white rotate-[270deg] shrink-0" />
          )}
        </div>
      ))}
    </div>
  );
}

BankStatementSummaryCards.displayName = "BankStatementSummaryCards";
